export const DEFAULT_URL_SHORTENER_MODAL_STATE = {
    buttonText: 'Copy',
    error: null,
    modalOpen: false,
    shortenedUrl: 'Loading...',
};
